import { Link } from "react-router-dom";
import { META } from "../../data/reportContent";

export const ExecSummaryNav = () => (
  <nav className="report-nav no-print" data-testid="execsummary-nav">
    <div className="report-nav-inner">
      <div className="report-nav-title">
        {META.title}
        <span>Executive Summary</span>
      </div>
      <div className="report-nav-actions">
        <Link className="report-nav-link" to="/report" data-testid="execsummary-nav-fullreport-link">
          Full Report
        </Link>
        <Link className="report-nav-link" to="/executive-summary/print" data-testid="execsummary-nav-print-link">
          Print / Save PDF
        </Link>
      </div>
    </div>
  </nav>
);
